"use client";

import Link from "next/link";
import { usePagesVisibility } from "@/hooks/use-pages-visibility";
import { isHrefVisibleForUser } from "@/types/site-settings";

const FOOTER_LINKS = [
	{ href: "/", label: "Home" },
	{ href: "/lascuola", label: "La Scuola" },
	{ href: "/documentazione/modulistica", label: "Modulistica" },
	{ href: "/documentazione/circolari", label: "Circolari" },
	{ href: "/news", label: "News" },
	{ href: "/openday", label: "Open Day" },
	{ href: "/contatti", label: "Contatti" },
	{ href: "/area-riservata", label: "Area Riservata" },
];

export default function FooterNavLinks({
	linkClass,
}: {
	linkClass: string;
}) {
	const { pages } = usePagesVisibility();

	const visibleLinks = FOOTER_LINKS.filter((item) =>
		isHrefVisibleForUser(item.href, pages),
	);

	return (
		<ul className="space-y-1 text-sm">
			{visibleLinks.map((item) => (
				<li key={item.href}>
					<Link href={item.href} className={linkClass}>
						{item.label}
					</Link>
				</li>
			))}
		</ul>
	);
}
